import Breadcrumb from "../components/Breadcrumb";
import EditUser from "../components/EditUser";
const EditUserPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Edit User" />

      {/* AddRoleLayer */}
      <EditUser />
    </>
  );
};

export default EditUserPage;
